import React from 'react'

function Welcome() {
    return (
        <div className='welcome-tab'>
            <p>Welcome to Our store</p>
        </div>
    )
}

export default Welcome